import { render, staticRenderFns } from "./JUpload.vue?vue&type=template&id=67ab578b&scoped=true"
import script from "./JUpload.vue?vue&type=script&lang=js"
export * from "./JUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ab578b",
  null
  
)

export default component.exports